export default __webpack_public_path__ + "static/media/Digital_3_Pin_Output@2x.b9e03a61.png";